/**
 * Bold pass, 2026-08-12 — the one behaviour CSS alone cannot express.
 *
 * The sticky add-to-cart bar is position:fixed, so at the bottom of a product
 * page it sat on top of the footer and covered the store address and the Shop
 * menu. Parking it once the footer enters the viewport needs to know where the
 * footer is, which is a scroll-position question, not a style question.
 *
 * Nothing here changes content, and the bar is only ever moved out of the way —
 * it never covers anything it did not already cover.
 */
(function () {
  window.__boldJs = 'loaded';
  const bar = document.querySelector('sticky-add-to-cart');
  const footer = document.querySelector('footer');
  if (!bar || !footer || typeof IntersectionObserver === 'undefined') {
    window.__boldJs = 'no-sticky-bar-on-this-template';
    return;
  }

  // The theme scrolls .page-wrapper, not the document, so the observer has to
  // use it as its root or every entry reports isIntersecting: false.
  const root = document.querySelector('.page-wrapper') || null;

  new IntersectionObserver(
    function (entries) {
      for (const entry of entries) {
        bar.classList.toggle('bold-parked', entry.isIntersecting);
        window.__boldJs = 'observing:' + entry.isIntersecting;
      }
    },
    { root: root, threshold: 0 }
  ).observe(footer);
  window.__boldJs = 'observing';
})();
